module.exports = __webpack_public_path__ + "static/media/128-spain.de89af00.svg";